import { getRegionKey, RegionKey } from "@certn/utils";

export const regions: Record<RegionKey, string> = {
  ca: "North America",
  uk: "Europe, Middle East and Africa",
  au: "Asia Pacific",
};
// Map region key to country alpha-2 code
export const regionToCountryCode: Record<RegionKey, string> = {
  ca: "CA",
  uk: "GB",
  au: "AU",
};

export const currentRegion = getRegionKey();
